export default __webpack_public_path__ + "static/media/xd.3f781232.png";